var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"businesslicense"}},[_c('div',{staticClass:"item"},[_c('img',{staticClass:"item-img",attrs:{"src":"//acdn.mulazim.com/company_info/yingyezhizhao.png"},on:{"click":function($event){return _vm.previewImg('//acdn.mulazim.com/company_info/yingyezhizhao.png')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }